import logoLight from "@/assets/brand/logo-horizontal-claro.svg";
import logoDark from "@/assets/brand/logo-horizontal-escuro.svg";
import { cn } from "@/lib/utils";

/**
 * Logo horizontal oficial ("eliveuton."). Troca a variante pelo tema: a de
 * texto escuro no claro e a de texto claro no `.dark`. A altura vem de
 * `className` (ex.: `h-[30px]`); a largura acompanha a proporção do SVG.
 */
export function BrandLogo({ className }: { className?: string }) {
  return (
    <span className={cn("inline-flex shrink-0", className)}>
      <img src={logoLight} alt="Eliveuton Souza" className="h-full w-auto dark:hidden" />
      <img src={logoDark} alt="Eliveuton Souza" className="hidden h-full w-auto dark:block" />
    </span>
  );
}
